import { render, staticRenderFns } from "./VCalendarView.vue?vue&type=template&id=74d3543c&"
import script from "./VCalendarView.vue?vue&type=script&lang=js&"
export * from "./VCalendarView.vue?vue&type=script&lang=js&"
import style0 from "./VCalendarView.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports